// src/components/SubmitTime/fields/HyperLinkField.tsx
// Modern React implementation of HyperLinkField (URL) custom field

import React, { useState, useEffect } from 'react';
import type { CustomFieldProps } from '../types';
import './HyperLinkField.css';

interface HyperLinkFieldProps extends CustomFieldProps {}

export const HyperLinkField: React.FC<HyperLinkFieldProps> = ({
  customField,
  canEdit,
  handleDynamicInputChange,
  UpdateCustomFields,
  showRequiredError,
}) =>
{
  const [value, setValue] = useState<string>(
    customField.Value === null || customField.Value === undefined ? '' : String(customField.Value),
  );
  const [editableValue, setEditableValue] = useState<string>(value);

  useEffect(() =>
  {
    const newValue =
      customField.Value === null || customField.Value === undefined
        ? ''
        : String(customField.Value);
    setValue(newValue);
    setEditableValue(newValue);
  }, [customField.Value, customField.CustomFieldValueId]);

  const ensureProtocol = (url: string): string =>
  {
    if (!url || url.trim() === '') return '';
    const trimmed = url.trim();
    if (
      trimmed.substring(0, 7) === 'http://' ||
      trimmed.substring(0, 8) === 'https://' ||
      trimmed.substring(0, 6) === 'ftp://'
    )
    {
      return trimmed;
    }
    return 'http://' + trimmed;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    const newValue = event.target.value;
    setValue(newValue);
    handleDynamicInputChange(customField.CustomFieldId, newValue);
  };

  const handleBlur = () =>
  {
    if (!value) return;

    const finalValue = ensureProtocol(value);

    if (finalValue !== value)
    {
      setValue(finalValue);
      handleDynamicInputChange(customField.CustomFieldId, finalValue);
    }

    if (finalValue !== editableValue)
    {
      setEditableValue(finalValue);
      if (UpdateCustomFields)
      {
        UpdateCustomFields(customField);
      }
    }
  };

  const isFieldDisabled = !canEdit || !customField.ConversationIsEnable;

  return (
    <div className="hyperlink-field-wrapper">
      <input
        type="text"
        className={`corgee-inpuSubmitTimet right${showRequiredError ? ' submit-required-error' : ''}`}
        disabled={isFieldDisabled}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={customField.Placeholder || 'http://'}
      />
      {value && !isFieldDisabled && (
        <a
          href={ensureProtocol(value)}
          target="_blank"
          rel="noopener noreferrer"
          className="hyperlink-open-link"
          title="Open link"
        >
          ↗
        </a>
      )}
    </div>
  );
};

export default HyperLinkField;
